export const paths = {
  root: '/',
  signIn: '/sign-in',
  authError: '/auth/error',
  dashboard: '/dashboard',
  skillsProfile: '/skills-profile',
  activity: '/activities/:activityId',
  digitalSkill: '/skills/:skillId',
  certificate: '/certificates/:publicId',
  leaderboard: '/leaderboard',
  careerProfile: '/career-profile/:careerId',
  cv: '/cv',
  aiUsagePolicy: '/using-ai-tools-safely',
  explore: '/explore',
  checkIn: '/check-in',
  checkInCallback: '/check-in/callback',
  addActivity: {
    root: '/add-activity',
    confirm: '/add-activity/confirm',
    celebrate: '/add-activity/celebrate',
  },
  activityDetail: (id: string) => `/activities/${id}`,
  admin: {
    root: '/admin',
    login: '/admin/login',
    activities: '/admin/activities',
    activityEdit: (id: string) => `/admin/activities/${id}`,
    careers: '/admin/careers',
    careerEdit: (id: string) => `/admin/careers/${id}`,
  },
};
